import { FIELD_TYPES } from "constants/template-field-type";
import { HEADER_POPUP_OPTIONS } from "constants/header-popup";

import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    logoPopup: {
      type: FIELD_TYPES.COMBO,
      label: "Logo Popup",
      options: HEADER_POPUP_OPTIONS
    },
    mobileStickySignup: { type: FIELD_TYPES.BOOLEAN, label: "Mobile sticky signup (In test don't touch)" },
    shouldAddTagsToHeader: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Show tags in header (In test don't touch)"
    },
    shouldHaveEnhancedProducts: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Show enhanced products in header (In test don't touch)"
    },
    mobileDarkHeader: { type: FIELD_TYPES.BOOLEAN, label: "Mobile dark header (In test don't touch)" },
    isExistingAccountHeader: { type: FIELD_TYPES.BOOLEAN, label: "Use existing account header (welcome back page)" },
    simulateContactSalesProminantButtonExistingUsersTest: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Simulate contact sales prominant button for existing users"
    },
    simulateContactSalesWebsitePagesNewUsersTest: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Simulate contact sales test for new users in website pages"
    },
    simulateContactSalesProminantButtonNewUsersLPsTest: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Simulate contact sales prominant button for new users in LPs"
    },
    showSuccessStoriesInHeader: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Show success stories in header (In test don't touch)"
    },
    showProductSwitcherLogoInHeader: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Show product switcher in header (In test don't touch)"
    },
    overrideClusterLogo: {
      type: FIELD_TYPES.NESTED,
      label: "Override cluster logo (don't touch)",
      fields: {
        url: { type: FIELD_TYPES.TEXT, label: "Override Logo Click URL" },
        src: { type: FIELD_TYPES.TEXT, label: "Override Logo Image" },
        alt: { type: FIELD_TYPES.TEXT, label: "Override Logo Alt Text" }
      }
    }
  }
};
